import { StackScreenProps } from "@react-navigation/stack";
import React, { useState } from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useShipmentValue } from "@/hooks/domain/shipmentValue";
import { useStoreHighlight } from "@/hooks/domain/storeHighlights";
import { useStoreById } from "@/hooks/domain/stores";
import { HomeNavigation, HomeStackParamList } from "@/navigation/stacks/HomeStack";
import analytics from "@/services/analytics";

import StoreHomeMobile from "./StoreHome.mobile";
import StoreHomeWeb from "./StoreHome.web";
import StoreProfileModal from "./components/StoreProfileModal";

type ScreenProps = StackScreenProps<HomeStackParamList, "storeHome">;

const StoreHome = ({ route }: ScreenProps) => {
  const storeId = route.params?.storeId;

  const { isWebMode } = useViewport();
  const { goBack, navigate, setOptions } = useAppNavigation<HomeNavigation>();

  const [storeProfileModalVisible, setStoreProfileModalVisible] = useState(false);

  const { data: store, isLoading: isLoadingStore } = useStoreById(storeId, {
    onSuccess: (data) => {
      setOptions({ title: data?.nome_fantasia });
      analytics.logEvent("opened_vendor_screen", {
        vendor_name: data?.nome_fantasia,
      });
    },
    onError: () => {
      goBack();
    },
  });

  const { data: storeHighlights, isLoading: isLoadingStoreHighlights } = useStoreHighlight(
    store?._id,
    {
      enabled: !!store,
    }
  );

  const { data: shipmentData, isLoading: isLoadingShipmentData } = useShipmentValue(storeId, {
    enabled: !!storeId,
  });

  const onSelectHighlight = (id: string) => {
    navigate("storeHighlight", {
      highlightId: id,
    });
  };

  const Screen = isWebMode ? StoreHomeWeb : StoreHomeMobile;

  return (
    <>
      <Screen
        store={store}
        isLoadingStore={isLoadingStore}
        storeHighlights={storeHighlights}
        isLoadingStoreHighlights={isLoadingStoreHighlights}
        shipmentValue={shipmentData?.shipmentValue}
        isLoadingShipmentValue={isLoadingShipmentData}
        onOpenProfile={() => setStoreProfileModalVisible(true)}
        onSelectHighlight={onSelectHighlight}
      />
      <StoreProfileModal
        isOpen={storeProfileModalVisible}
        store={store}
        onClose={() => setStoreProfileModalVisible(false)}
      />
    </>
  );
};

export default StoreHome;
